/*
 * ConfirmationModal Messages
 *
 * This contains all the text for the ConfirmationModal component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelButton: {
    id: 'app.components.ConfirmationModal.cancelButton',
    defaultMessage: 'Cancel',
  },
  confirmButton: {
    id: 'app.components.ConfirmationModal.confirmButton',
    defaultMessage: 'Ok',
  },
});
